import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import store from "../../../store";
import DeviceStorage from "../../../components/DeviceStorage/DeviceStorage";
import { resolve } from "path";
import { ENABLE_HTTPS } from "../../RequestManagerConstants";
import Device from "../../../devices/device";

class TVEverywhereCheckTask extends AbstractRequestTask {
  constructor(params) {
    super(params);    
  }

  getParams() {
    const params = super.getParams();
    const {api_version, ...restParams} = params;

    const {user = {}} = store.getState();
    const user_token = user.user_token;
    return Object.assign(restParams, { user_token });
  }

  isValid(data) {
    if(data && data.data && data.data.hasOwnProperty("isChecked")) {
      return true
    }
    return false;
  }

  getUrl() {
    const http = "https://";
    // const url = "userdata-pre.clarovideo.net"
    const url = Launcher.get("akamai_mfwk");
    return `${http}${url}/services/user/v1/profile/data/check`;
  }

  getShowErrorModal(){
		return false;
	}

  showModalRetry() {
    return false
  }

  getEncType() {
    return 'application/x-www-form-urlencoded';
  }

  getIsByHttps(){
    return ENABLE_HTTPS;
  }

}

export default TVEverywhereCheckTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/user/TVEverywhereCheckTask.js